(function ($) {
    $(function () {

        // Down arrow smooth scroll
        //---------------------------------------------------
        let scrollAnimation;

        function smoothScrollTo(targetPosition, duration) {
            cancelAnimationFrame(scrollAnimation);

            const startPosition = window.pageYOffset;
            const distance = targetPosition - startPosition;
            const startTime = performance.now();

            function easeInOutCubic(t) {
                return t < 0.5
                    ? 4 * t * t * t
                    : 1 - Math.pow(-2 * t + 2, 3) / 2;
            }

            function scroll(currentTime) {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easedProgress = easeInOutCubic(progress);

                window.scrollTo(0, startPosition + distance * easedProgress);

                if (progress < 1) {
                    scrollAnimation = requestAnimationFrame(scroll);
                }
            }

            scrollAnimation = requestAnimationFrame(scroll);
        }

        $(".block-hero-homepage .triangle-btn").on("click", function (e) {
            e.preventDefault();

            const currentBlock = $(this).closest(".block-hero-homepage");

            if (!currentBlock.length) {
                return;
            }

            const scrollAmount = currentBlock.outerHeight() / 2;
            const targetPosition = Math.min(
                $(window).scrollTop() + scrollAmount,
                $(document).height() - $(window).height()
            );

            smoothScrollTo(targetPosition, 200);
        });

    });
})(jQuery);
